import { gql } from "@apollo/client";

export const SINGLE_CREATOR_CARD = gql`
  query CreatorCard($cardId: String!) {
    creatorCard(cardId: $cardId) {
      _id
      isActive
      scopeUse
      scopeVis
      userGroups
      ui {
        title
        category
        slug
        useType
        rarity
        badge
        explanation
        flavorText
        hoverEffect
        hoverEffectSrc
        hoverEffectSrcBefore
        image
        game
        campaign {
          color
          campaignBlurbs {
            creatorCard {
              description
              linkText
              linkUrl
              image
              sponsorName
            }
          }
        }
      }
      facet {
        type
        mechanic
        game
      }
    }
  }
`;
